var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: {
      'toggle-menu-root': _vm.menu
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "disabled": _vm.menu
    },
    scopedSlots: _vm._u([{
      key: "activator",
      fn: function (_ref) {
        var on = _ref.on,
          attrs = _ref.attrs;
        return [_c('div', _vm._g(_vm._b({
          staticClass: "local-data-save-toggle",
          class: {
            'local-data-save-toggle--disabled': !_vm.hasSession || _vm.loadingPreference,
            'local-data-save-toggle--on': _vm.saveDataLocally,
            'local-data-save-toggle--menu': _vm.menu
          },
          attrs: {
            "role": "switch",
            "tabindex": "0",
            "aria-checked": String(_vm.saveDataLocally)
          },
          on: {
            "click": _vm.requestToggle,
            "keydown": [function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) return null;
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }, function ($event) {
              if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) return null;
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }]
          }
        }, 'div', attrs, false), on), [_c('v-icon', {
          staticClass: "local-data-save-toggle__icon",
          attrs: {
            "small": ""
          }
        }, [_vm._v("mdi-content-save-outline")]), _c('span', {
          staticClass: "local-data-save-toggle__label"
        }, [_vm._v("Save on phone")]), _c('v-switch', {
          staticClass: "local-data-save-toggle__switch",
          attrs: {
            "input-value": _vm.saveDataLocally,
            "color": "blue lighten-1",
            "dense": "",
            "inset": "",
            "hide-details": "",
            "readonly": "",
            "aria-label": _vm.ariaLabel,
            "disabled": !_vm.hasSession || _vm.loadingPreference || _vm.saving
          },
          nativeOn: {
            "click": function ($event) {
              $event.stopPropagation();
              $event.preventDefault();
              return _vm.requestToggle.apply(null, arguments);
            }
          }
        })], 1)];
      }
    }])
  }, [_c('span', [_vm._v(_vm._s(_vm.tooltipText))])]), _c('v-dialog', {
    attrs: {
      "content-class": "app-dialog local-save-dialog",
      "attach": ".v-application",
      "max-width": "520",
      "retain-focus": false
    },
    on: {
      "input": _vm.onConfirmDialogInput,
      "click:outside": _vm.cancelLocalSave
    },
    model: {
      value: _vm.confirmDialog,
      callback: function ($$v) {
        _vm.confirmDialog = $$v;
      },
      expression: "confirmDialog"
    }
  }, [_c('v-card', [_c('v-card-title', {
    staticClass: "local-save-dialog__title"
  }, [_vm._v(" Save data on phone only? ")]), _c('v-card-text', [_c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" The data will be saved only on the recording phone(s), not on this computer and not in the cloud during recording. ")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" Make sure each recording phone has the OpenCap iOS app version 2.1.2 or later. Save on phone was added in that version. ")]), _c('p', {
    staticClass: "mb-2"
  }, [_vm._v(" You will need to upload the videos from the iOS app on the phone(s) before OpenCap can process the data and show results. ")]), _c('p', {
    staticClass: "mb-0 local-save-dialog__recommendation"
  }, [_vm._v(" Use this when you want to record first and upload the videos later, typically when internet connection is slow. ")])]), _c('v-card-actions', [_c('v-spacer'), _c('v-btn', {
    attrs: {
      "text": "",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.cancelLocalSave
    }
  }, [_vm._v("Cancel")]), _c('v-btn', {
    attrs: {
      "color": "blue darken-1",
      "text": "",
      "disabled": _vm.saving
    },
    on: {
      "click": _vm.confirmLocalSave
    }
  }, [_vm.saving ? _c('v-progress-circular', {
    staticClass: "mr-2",
    attrs: {
      "indeterminate": "",
      "color": "grey",
      "size": "14",
      "width": "2"
    }
  }) : _vm._e(), _vm._v(" Save on phone ")], 1)], 1)], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }